import { useXDomain } from 'app-support/contexts/XDomainContext'

export function useAppURLs() {
  let domain = useXDomain()
  // parse the stage, assume if domain starts with carsys or wwww, that we're on prod
  let stage = domain.search(/^wwww./gi) !== -1 || domain.search(/^carsys./gi) !== -1 ? '' : `${domain.split('.')[0]}.`
  // handle edge case for localhost, send them to staging instead
  if (domain === 'localhost' || domain === 'localhost.carsys.online') {
    stage = 'staging.'
    domain = 'staging.carsys.support'
  }
  return {
    lessorAdmin: `https://lessor-admin.${domain}`,
    conceptAdmin: `https://concept-admin.${domain}`,
    spotOn: `https://spoton.${domain}`,
    tenants: `https://${stage}admin.tenants.${domain.replace(stage, '')}?email=[email]&token=[refreshToken]`,
    jobs: `https://${stage}admin.jobs.${domain.replace(stage, '')}?email=[email]&token=[refreshToken]`
  }
}
